export default __webpack_public_path__ + "static/media/home_thumb_bs.5bf9bba2.png";